import { ProgressBarMode } from '@angular/material/progress-bar';
import { IReportBuilderState } from '../report-builder.store';

export interface ILoaderDisplay {
  heading: string;
  message?: string;
  mode: ProgressBarMode;
  progress?: number;
}

export function getReportBuilderLoader(
  state: IReportBuilderState<unknown>,
  message?: string
): ILoaderDisplay | undefined {
  if (!state.loading) {
    return;
  }
  if (state.progress === undefined) {
    return { heading: 'Building data', mode: 'query', message };
  }
  if (state.progress === 1) {
    return { heading: 'Formatting data', mode: 'indeterminate', message };
  }
  return {
    heading: 'Downloading data',
    mode: 'determinate',
    progress: state.progress,
    message,
  };
}
